import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

import { Button, Form, Grid, Header, Image, Message, Segment, Input } from 'semantic-ui-react';
import logoImg from '../../../Assets/Images/DDS_Logo.jpg';
import { utils } from '../../../helpers/utils';
import { useChangePasswordForm } from './useChangePasswordForm';

export type ChangePasswordFormProps = {
  closePopup: Function,
}
const ChangePasswordForm: React.FC<ChangePasswordFormProps> = ({ closePopup }) => {

  const [values, errors, touched, isLoading, isSubmitting, isValid, errorMessage, registerRef, handleChange, handleBlur, handleSubmit] = useChangePasswordForm(closePopup);
  function handleSubmitData() {
    handleSubmit();
  }

  //console.log(errors);
  const errorText: string[] = [];
  Object.keys(errors).forEach((key) => {
    errorText.push(errors[key]);
  })
  return (
    <>
      <Form size='large' loading={isSubmitting}>
        <Form.Input
          fluid
          required
          label='Current Password'
          placeholder='Current Password'
          type='password'
          onChange={(event, data) => {
            handleChange(data.value, 'currentPassword');
          }}
          onBlur={
            () => { handleBlur('currentPassword') }
          }
          
          error={!(!errors.currentPassword || !touched.currentPassword) ? true : false}
        />
        <Form.Input
          fluid
          required
          label='New Password'
          placeholder='New Password'
          type='password'
          onChange={(event, data) => {
            handleChange(data.value, 'newPassword');
          }}
          onBlur={
            () => { handleBlur('newPassword') }
          }
          
          error={!(!errors.newPassword || !touched.newPassword) ? true : false}
        />
        <Form.Input
          fluid
          required
          label='Confirm New Password'
          placeholder='Confirm New Password'
          type='password'
          onChange={(event, data) => {
            handleChange(data.value, 'confirmPassword');
          }}
          onBlur={
            () => { handleBlur('confirmPassword') }
          }
          onKeyPress={(event: React.KeyboardEvent) => {
            if (event.key === 'Enter') {
              handleSubmit();
            }

          }}
          error={!(!errors.confirmPassword || !touched.confirmPassword) ? true : false}
        />
        <Button
          type='button'
          onClick={handleSubmitData}
          color='blue' size='large'>
          Submit
        </Button>
        <Button
          type='button'
          onClick={()=>{closePopup()}}
          size='large'>
          Cancel
        </Button>

        {
          errorMessage != null &&
          <Message
            negative
            header='Something goes wrong:'
            content={utils.formatCamelText(errorMessage) }
          />
        }
        {
          Object.keys(errors).length > 0 &&
          <Message
            negative
            list={errorText}
          />
        }
      </Form>
    </>
  )
}

export default ChangePasswordForm